import { ContractDetailStatus, DiscountType, ReleaseType, VoucherType } from '@ibk/shared-types';
import { RechargePaymentMethod, RechargeState, VoucherContractRechargeType } from '../types/recharge';
export const getProductName = (voucherTypeId, t) => {
    switch (voucherTypeId) {
        case 'VA':
            return t('recharge.product.food-assistance');
        case 'VR':
            return t('recharge.product.meal-assistance');
        case 'VR_VA':
            return t('recharge.product.vr-va');
        case 'VA_PAT':
            return t('recharge.product.va_pat');
        case 'VR_PAT':
            return t('recharge.product.vr_pat');
        default:
            return voucherTypeId;
    }
};
export const getActiveContractProducts = (products) => {
    return (products || []).filter(product => product.status === ContractDetailStatus.ACTIVE);
};
export const formatDiscount = (discountType, discountValue, t) => {
    switch (discountType) {
        case DiscountType.NO_DISCOUNT:
            return t('noDiscount');
        case DiscountType.PERCENTAGE:
            return `${(discountValue ?? 0).toFixed(2)}%`;
        case DiscountType.TOTAL:
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(discountValue ?? 0);
        default:
            return t('noDiscount');
    }
};
export const getReleaseTypeLabel = (releaseType, t) => {
    switch (releaseType) {
        case ReleaseType.DAILY:
            return t('releaseType.daily');
        case ReleaseType.MONTHLY:
            return t('releaseType.monthly');
        default:
            return releaseType;
    }
};
export const formatCompetenceDate = (date) => {
    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};
export const formatValuePerBeneficiary = (hasIndividualValue, consensusValue, amountDaily, releaseType, t) => {
    if (hasIndividualValue) {
        return t('recharge.value.defined-by-beneficiary');
    }
    const formattedValue = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(releaseType === ReleaseType.DAILY ? amountDaily : consensusValue);
    const suffix = releaseType === ReleaseType.MONTHLY ? t('recharge.value.suffix.monthly') : t('recharge.value.suffix.daily');
    return `${formattedValue} ${suffix}`;
};
export const getRechargeStatusLabel = (rechargeState, t) => {
    switch (rechargeState) {
        case RechargeState.APPROVED:
            return t('rechargeStatus.approved');
        case RechargeState.PENDING:
            return t('rechargeStatus.pending');
        case RechargeState.PROCESSING:
            return t('rechargeStatus.processing');
        case RechargeState.COMPLETED:
            return t('rechargeStatus.completed');
        case RechargeState.FAILED:
            return t('rechargeStatus.failed');
        case RechargeState.CANCELED:
            return t('rechargeStatus.canceled');
        default:
            return rechargeState;
    }
};
export const getRechargeTypeLabel = (rechargeType, isInPeriod, t) => {
    if (!isInPeriod) {
        return '';
    }
    if (rechargeType === VoucherContractRechargeType.HAPPY_HOLIDAYS_END_OF_THE_YEAR) {
        return t('rechargeType.happyHolidaysEndOfTheYearRecharge');
    }
    return t('rechargeType.recurrentRecharge');
};
export const getPaymentMethodLabel = (paymentMethod, t) => {
    switch (paymentMethod) {
        case RechargePaymentMethod.PIX:
            return t('recharge.sidebarComponent.paymentMethod.pix');
        case RechargePaymentMethod.BANK_SLIP:
            return t('recharge.sidebarComponent.paymentMethod.bankSlip');
        case RechargePaymentMethod.ACCOUNT_BALANCE:
            return t('recharge.sidebarComponent.paymentMethod.account');
        default:
            return '';
    }
};
const BASE_VOUCHER_TYPES = new Set([VoucherType.VA, VoucherType.VR, VoucherType.VR_VA]);
const PAT_VOUCHER_TYPES = new Set([VoucherType.VA_PAT, VoucherType.VR_PAT]);
const PAT_SUFFIX_PATTERN = /\s+PAT\b\s*$/i;
export const isPatVoucherType = (voucherTypeDescription) => PAT_VOUCHER_TYPES.has(voucherTypeDescription);
export const stripPatSuffix = (productName) => productName.replace(PAT_SUFFIX_PATTERN, '');
export const getBaseProducts = (contractedProducts) => (contractedProducts || []).filter(p => BASE_VOUCHER_TYPES.has(p.voucherTypeDescription));
export const getPatProducts = (contractedProducts) => (contractedProducts || []).filter(p => PAT_VOUCHER_TYPES.has(p.voucherTypeDescription));
export const hasBaseContract = (contractedProducts) => getBaseProducts(contractedProducts).length > 0;
export const hasPatContract = (contractedProducts) => getPatProducts(contractedProducts).length > 0;
export const hasAllContractTypes = (contractedProducts) => hasBaseContract(contractedProducts) && hasPatContract(contractedProducts);
